<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.625 5.875C12.625 7.32475 11.4497 8.5 10 8.5C8.55025 8.5 7.375 7.32475 7.375 5.875C7.375 4.42525 8.55025 3.25 10 3.25C11.4497 3.25 12.625 4.42525 12.625 5.875Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.0008 10.75C7.45747 10.75 5.52783 12.2607 4.7377 14.3972C4.4311 15.2261 5.13958 16 6.02347 16H9.25082" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.5625 10.75H16.1875C16.6707 10.75 17.0625 11.1417 17.0625 11.625V16L14.875 14.6875L12.6875 16V11.625C12.6875 11.1417 13.0793 10.75 13.5625 10.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'MyAdsIcon'
}
</script>

